import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';

import { useMessages } from '../../../hooks/useMessages';
import { useEditMode } from './useEditMode';
import ActionBar from './ActionBar';
import FieldSection from './FieldSection';
import { getFields } from './fields/fieldsTabMarketingPrefs';
import BrandSegmentation from './BrandSegmentation';

const TabMarketingPreferences = ({ model }) => {
    const { L } = useMessages();
    const { renderEditButtons, handleChange } = useEditMode(model);

    const { user } = useSelector((state) => state.auth);
    const { market, features } = user || {};

    const sections = useMemo(
        () => getFields(L, market, features),
        [L, market, features]
    );

    return (
        <Box sx={{ py: 1 }}>
            <ActionBar model={model}>{renderEditButtons()}</ActionBar>
            {sections.map((section, index) => (
                <FieldSection
                    key={index}
                    section={section}
                    model={model}
                    onChange={handleChange}
                />
            ))}
            <BrandSegmentation model={model} />
        </Box>
    );
};

export default TabMarketingPreferences;
